export const RES = '/Aeblegarden/'
export const API = 'https://eidodata.aeblegaarden.eco-village.dk/v1/'
// export const API = "https://pratik-dev.api5.estatetool.net/v1/"
const BUN = 'https://eidoisometri.b-cdn.net/'
const EMAIL_API = "send/mail"
const TESTLEAD = "leadtool?campaign="
export const POST_TESTLEAD = "api2/post_leadtool/"
export const LEAD_ACCEPTED_STATUS = "100"
export const LEAD_PHONE_REJECTED_STATUS = "114"


// Logging API Endpoints
export const LOGGING_ID = 4;
export const LOGGING_BASEURL = "https://logging.eido.dk";
export const GET_LOGGINGCONFIG = `${LOGGING_BASEURL}/v1/logging/get-config/${LOGGING_ID}`;
export const CHECK_USER_IDENTIFIER = `${LOGGING_BASEURL}/v1/logging/check-user-identifier`;
export const START_SESSION = `${LOGGING_BASEURL}/v1/logging/session/start`;
export const HEART_SESSION = `${LOGGING_BASEURL}/v1/logging/session/heartbeat`;
export const SESSION_PAGE = `${LOGGING_BASEURL}/v1/logging/session/pages`;
export const SEND_CLICKS = `${LOGGING_BASEURL}/v1/logging/clicks`;
export const GET_ELEMENT_IDENTIFIER = `${LOGGING_BASEURL}/v1/logging/get-element-identifier`;
export const SEND_FILTERS = `${LOGGING_BASEURL}/v1/logging/filters`;
export const SEND_SORTING = `${LOGGING_BASEURL}/v1/logging/sorting`;

export const FLOORPLAN = `${BUN}defaults/plantegning.jpg`

export const ISO_CONFIG = `${RES}data/iso`        + '.json'
export const MAP_CONFIG = `${RES}data/map`        + '.json'

export const COLORS     = `${RES}data/colors`     + '.json'
export const CONTACT    = `${RES}data/contact`    + '.json'
export const NAVLINKS   = `${RES}data/nav`        + '.json'
export const HIGHLIGHTS = `${RES}data/highlights` + '.json'

export const ISO_FRAMES = `${BUN}`
export const MAP_FRAMES = `${RES}map`
export const STATICS    = `${RES}logos/`

export const BOOT       = `${API}bootstrap`
export const IP         = `${API}getip`    

const BF1 = '/housingbenefits?GrossIncome='
const BF2 = '&SiteID='

export const PROJECT   = ( PID, LNG='da' )              => PID ? `${API}projects/${PID}?Language=${LNG}`                            : null
export const PRJ       = ( PID )                        => PID ? `${API}projects/${PID}`                                            : null
export const UNITS     = ( PID, LNG='da' )              => PID ? `${PRJ(PID)}/units?Language=${LNG}`                                : null
export const VERSION   = ( PID )                        => PID ? `${PRJ(PID)}/unitsdataversion`                                     : null
export const LOG       = ( PID )                        => PID ? `${PRJ(PID)}/logs`                                                 : null
export const BENEFIT   = ( PID, ID, INC, SITE )         => PID ? `${PRJ(PID)}/units/${ID}${BF1}${INC}${BF2}${SITE}`                 : null
export const UNIT      = ( PID, ID, LNG='da' )          => PID ? `${PRJ(PID)}/units/${ID}?Language=${LNG}`                          : null
export const COMPARE   = ( PID, LIST_OF_IDS, LNG='da' ) => PID ? `${PRJ(PID)}/unitscompare?UnitIDs=${LIST_OF_IDS}&Language=${LNG}`  : null
export const PAGE      = ( PID, PAGEID, LNG='da' )      => PID ? `${PRJ(PID)}/pages/${PAGEID}?Language=${LNG}`                      : null
export const DOWNLOADS = ( PID, LNG='da' )              => PID ? `${PRJ(PID)}/downloads?Language=${LNG}`                            : null
export const EMAIL              = () =>  `${API}${EMAIL_API}`
export const MOVEINCALCULATIONS   = (PID,ID)=> PID ? `${PRJ(PID)}/units/${ID}/calculation/movein` : null
export const DEPOSITECALCULATIONS = (PID , ID )=> PID ? `${PRJ(PID)}/units/${ID}/calculation/deposit` : null
export const PREPAIDCALCULATIONS = ( PID , ID)=> PID ? `${PRJ( PID)}/units/${ID}/calculation/prepaid` : null
export const MAPBOX   = ( PID )              => PID ? `${API}projects/${PID}`                            : null
export const GETLEADTOKEN = ( campaignId )=> `${API}${TESTLEAD}${campaignId}`

// Logging API Helpers
export const GET_CHECKUSER_IDENTIFIER = ( name ) => `${CHECK_USER_IDENTIFIER}?name=${name}`
export const GET_LOGGING_CONFIG = () => GET_LOGGINGCONFIG